module.exports = __webpack_public_path__ + "img/benifits-of-gamyfie-with-learning.3447506.jpg";